// extracted by mini-css-extract-plugin
export default {"title":"Blog_title__hSMi4","container":"Blog_container__5NR3A","box":"Blog_box__lSCuF","text":"Blog_text__MCY3y"};